import React, { useState } from 'react';
import { useLang } from '../hooks/useLang';

const FAQ = () => {
  const { lang } = useLang();
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqData = {
    de: [
      {
        question: "Was genau ist Centeo?",
        answer: "Centeo ist ein intelligenter, KI-gestützter Fördermittelfinder, der speziell für Landwirte in Europa entwickelt wurde. Wir durchsuchen für Sie eine Datenbank mit über 400 Programmen – von allgemeinen EU-Subventionen bis hin zu speziellen regionalen Zuschüssen und privaten \"Hidden Gems\" – und finden genau die, die zu Ihrem Betrieb und Ihren Zielen passen."
      },
      {
        question: "Wie funktioniert der Prozess?",
        answer: "Wir haben den Prozess so einfach wie möglich gestaltet. Anstatt sich durch komplexe Formulare zu kämpfen, wählen Sie auf unserer Startseite einfach Ihr Ziel: \"Jährliche Prämien sichern\" für die schnelle Analyse Ihrer wiederkehrenden GAP-Zahlungen oder \"Neues Projekt finanzieren\" für Investitionen, Modernisierungen oder neue Vorhaben. Anschließend beantworten Sie wenige, einfache Fragen. Unser System analysiert im Hintergrund Ihre Angaben, vergleicht sie mit allen verfügbaren Programmen und präsentiert Ihnen eine nach Relevanz sortierte Ergebnisliste."
      },
      {
        question: "Was kostet die Nutzung von Centeo?",
        answer: "Wir bieten eine vollständige Analyse für eine einmalige Zahlung von 9,90 €. Es gibt kein Abonnement und keine versteckten Kosten."
      },
      {
        question: "Ist Centeo eine offizielle Förderberatung?",
        answer: "Nein. Centeo ist ein leistungsstarkes Informations- und Analyse-Tool, das Ihnen hilft, potenzielle Förderungen zu identifizieren. Wir bieten jedoch keine individuelle Rechts- oder Förderberatung an und füllen keine Anträge für Sie aus. Die Verantwortung für die Prüfung und die frist- und formgerechte Beantragung liegt allein bei Ihnen."
      },
      {
        question: "Welche Arten von Förderungen findet Centeo?",
        answer: "Unsere Datenbank umfasst weit mehr als nur die bekannten EU-Agrarsubventionen. Wir finden für Sie unter anderem: GAP-Direktzahlungen (Basisprämie, Öko-Regelungen etc.), Nationale und regionale Förderprogramme, Steuerliche Vorteile und Entlastungen, Zinsgünstige Kredite und Garantien von Förderbanken, Private Initiativen von Stiftungen oder Unternehmen (\"Hidden Gems\")."
      },
      {
        question: "Wie aktuell sind die Daten?",
        answer: "Unsere Datenbank mit über 400 Programmen wird kontinuierlich von unserem Team gepflegt und auf Basis neuer Veröffentlichungen von der EU, den Nationalstaaten und den Regionen aktualisiert. Wir legen besonderen Wert darauf, auch zeitlich begrenzte Ausschreibungen schnell zu erfassen."
      },
      {
        question: "Was bedeutet \"Kombinierbarkeits-Analyse\"?",
        answer: "Das ist eines unserer intelligentesten Features. Unser System erkennt, welche Förderprogramme miteinander \"gestapelt\" oder kombiniert werden können. Auf Ihrer Ergebnisseite zeigen wir Ihnen an, wenn ein gefundenes Programm mit anderen Förderungen kombiniert werden kann, um Ihr finanzielles Potenzial zu maximieren."
      },
      {
        question: "Wie funktioniert die Geld-zurück-Garantie?",
        answer: "Wir sind von der Qualität unserer Analyse überzeugt. Sollten Sie mit den Ergebnissen nicht zufrieden sein, bieten wir eine unkomplizierte 30-Tage-Geld-zurück-Garantie. Eine einfache E-Mail an unseren Support genügt, und wir erstatten den vollen Betrag zurück. Die genauen Bedingungen finden Sie in unseren AGB."
      },
      {
        question: "Sind meine Daten sicher?",
        answer: "Ja, absolut. Der Schutz Ihrer Daten hat für uns höchste Priorität. Ihre Betriebsdaten werden streng vertraulich behandelt und nur für die einmalige Analyse verwendet. Ihre Zahlungsdaten werden nicht von uns, sondern direkt von unserem zertifizierten Partner Stripe verarbeitet. Unsere Webseite und alle Datenübertragungen sind durchgehend HTTPS-verschlüsselt."
      }
    ],
    es: [
      {
        question: "¿Qué es exactamente Centeo?",
        answer: "Centeo es un buscador inteligente de subvenciones asistido por IA, desarrollado específicamente para agricultores en Europa. Buscamos en una base de datos de más de 400 programas – desde subvenciones generales de la UE hasta ayudas regionales especiales e iniciativas privadas \"Hidden Gems\" – y encontramos exactamente las que se adaptan a su explotación y objetivos."
      },
      {
        question: "¿Cómo funciona el proceso?",
        answer: "Hemos diseñado el proceso de la manera más simple posible. En lugar de luchar con formularios complejos, simplemente elija su objetivo en nuestra página de inicio: \"Asegurar primas anuales\" para el análisis rápido de sus pagos PAC recurrentes o \"Financiar nuevo proyecto\" para inversiones, modernizaciones o nuevas iniciativas. Luego responda unas pocas preguntas simples. Nuestro sistema analiza en segundo plano sus datos, los compara con todos los programas disponibles y le presenta una lista de resultados ordenada por relevancia."
      },
      {
        question: "¿Cuánto cuesta usar Centeo?",
        answer: "Ofrecemos un análisis completo por un pago único de 9,90 €. No hay suscripción ni costos ocultos."
      },
      {
        question: "¿Es Centeo una consultoría oficial de subvenciones?",
        answer: "No. Centeo es una herramienta de información y análisis potente que le ayuda a identificar subvenciones potenciales. Sin embargo, no ofrecemos asesoramiento legal o de subvenciones individual y no completamos solicitudes por usted. La responsabilidad de la verificación y la solicitud oportuna y correcta recae únicamente en usted."
      },
      {
        question: "¿Qué tipos de subvenciones encuentra Centeo?",
        answer: "Nuestra base de datos incluye mucho más que solo las conocidas subvenciones agrícolas de la UE. Encontramos para usted entre otros: Pagos directos PAC (prima básica, eco-esquemas, etc.), Programas de financiación nacionales y regionales, Ventajas fiscales y exenciones, Créditos con intereses favorables y garantías de bancos de fomento, Iniciativas privadas de fundaciones o empresas (\"Hidden Gems\")."
      },
      {
        question: "¿Qué tan actuales son los datos?",
        answer: "Nuestra base de datos con más de 400 programas es mantenida continuamente por nuestro equipo y actualizada basándose en nuevas publicaciones de la UE, los estados nacionales y las regiones. Ponemos especial énfasis en capturar rápidamente también las convocatorias con límite de tiempo."
      },
      {
        question: "¿Qué significa \"Análisis de Combinabilidad\"?",
        answer: "Esta es una de nuestras características más inteligentes. Nuestro sistema reconoce qué programas de financiación pueden ser \"apilados\" o combinados entre sí. En su página de resultados le mostramos cuando un programa encontrado puede ser combinado con otras subvenciones para maximizar su potencial financiero."
      },
      {
        question: "¿Cómo funciona la garantía de devolución de dinero?",
        answer: "Estamos convencidos de la calidad de nuestro análisis. Si no está satisfecho con los resultados, ofrecemos una garantía de devolución de dinero de 30 días sin complicaciones. Un simple email a nuestro soporte es suficiente, y reembolsamos el monto completo. Las condiciones exactas se encuentran en nuestros términos y condiciones."
      },
      {
        question: "¿Están seguros mis datos?",
        answer: "Sí, absolutamente. La protección de sus datos tiene la más alta prioridad para nosotros. Sus datos de explotación son tratados estrictamente confidenciales y solo se usan para el análisis único. Sus datos de pago no son procesados por nosotros, sino directamente por nuestro socio certificado Stripe. Nuestro sitio web y todas las transmisiones de datos están completamente encriptadas con HTTPS."
      }
    ],
    it: [
      {
        question: "Cos'è esattamente Centeo?",
        answer: "Centeo è un finder intelligente di finanziamenti assistito da IA, sviluppato specificamente per gli agricoltori in Europa. Cerchiamo in un database di oltre 400 programmi – dai sussidi generali UE agli aiuti regionali speciali e alle iniziative private \"Hidden Gems\" – e troviamo esattamente quelli che si adattano alla vostra azienda e ai vostri obiettivi."
      },
      {
        question: "Come funziona il processo?",
        answer: "Abbiamo progettato il processo nel modo più semplice possibile. Invece di lottare con moduli complessi, scegliete semplicemente il vostro obiettivo sulla nostra homepage: \"Assicurare premi annuali\" per l'analisi rapida dei vostri pagamenti PAC ricorrenti o \"Finanziare nuovo progetto\" per investimenti, modernizzazioni o nuove iniziative. Poi rispondete a poche, semplici domande. Il nostro sistema analizza in background i vostri dati, li confronta con tutti i programmi disponibili e vi presenta una lista di risultati ordinata per rilevanza."
      },
      {
        question: "Quanto costa usare Centeo?",
        answer: "Offriamo un'analisi completa per un pagamento unico di 9,90 €. Non c'è abbonamento né costi nascosti."
      },
      {
        question: "Centeo è una consulenza ufficiale per i finanziamenti?",
        answer: "No. Centeo è un potente strumento di informazione e analisi che vi aiuta a identificare potenziali finanziamenti. Tuttavia, non offriamo consulenza legale o sui finanziamenti individuale e non compiliamo domande per voi. La responsabilità della verifica e della domanda tempestiva e corretta spetta unicamente a voi."
      },
      {
        question: "Che tipi di finanziamenti trova Centeo?",
        answer: "Il nostro database include molto più dei soli noti sussidi agricoli UE. Troviamo per voi tra gli altri: Pagamenti diretti PAC (premio base, eco-schemi, ecc.), Programmi di finanziamento nazionali e regionali, Vantaggi fiscali ed esenzioni, Crediti a tasso agevolato e garanzie da banche di promozione, Iniziative private di fondazioni o aziende (\"Hidden Gems\")."
      },
      {
        question: "Quanto sono aggiornati i dati?",
        answer: "Il nostro database con oltre 400 programmi viene mantenuto continuamente dal nostro team e aggiornato sulla base di nuove pubblicazioni dall'UE, dagli stati nazionali e dalle regioni. Mettiamo particolare enfasi nel catturare rapidamente anche i bandi con limite di tempo."
      },
      {
        question: "Cosa significa \"Analisi di Combinabilità\"?",
        answer: "Questa è una delle nostre caratteristiche più intelligenti. Il nostro sistema riconosce quali programmi di finanziamento possono essere \"impilati\" o combinati tra loro. Nella vostra pagina dei risultati vi mostriamo quando un programma trovato può essere combinato con altri finanziamenti per massimizzare il vostro potenziale finanziario."
      },
      {
        question: "Come funziona la garanzia soddisfatti o rimborsati?",
        answer: "Siamo convinti della qualità della nostra analisi. Se non siete soddisfatti dei risultati, offriamo una garanzia soddisfatti o rimborsati di 30 giorni senza complicazioni. Una semplice email al nostro supporto è sufficiente, e rimborsiamo l'intero importo. Le condizioni esatte si trovano nei nostri termini e condizioni."
      },
      {
        question: "I miei dati sono sicuri?",
        answer: "Sì, assolutamente. La protezione dei vostri dati ha la massima priorità per noi. I vostri dati aziendali sono trattati strettamente confidenziali e utilizzati solo per l'analisi unica. I vostri dati di pagamento non sono elaborati da noi, ma direttamente dal nostro partner certificato Stripe. Il nostro sito web e tutte le trasmissioni di dati sono completamente crittografate HTTPS."
      }
    ]
  };

  const currentFAQ = faqData[lang] || faqData.de;

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {lang === 'es' ? 'Preguntas Frecuentes' : 
             lang === 'it' ? 'Domande Frequenti' : 
             'Häufig gestellte Fragen'}
          </h1>
          <p className="text-xl text-gray-600">
            {lang === 'es' ? 'Todo lo que necesita saber sobre Centeo' : 
             lang === 'it' ? 'Tutto quello che dovete sapere su Centeo' : 
             'Alles was Sie über Centeo wissen müssen'}
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {currentFAQ.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {item.question}
                </h3>
                <div className={`transform transition-transform duration-200 ${
                  openQuestion === index ? 'rotate-180' : ''
                }`}>
                  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              
              {openQuestion === index && (
                <div className="px-6 pb-4">
                  <div className="pt-2 border-t border-gray-100">
                    <p className="text-gray-700 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            {lang === 'es' ? '¿Más preguntas?' : 
             lang === 'it' ? 'Altre domande?' : 
             'Weitere Fragen?'}
          </h3>
          <p className="text-gray-600 mb-6">
            {lang === 'es' ? 'Nuestro equipo de soporte está aquí para ayudarle.' : 
             lang === 'it' ? 'Il nostro team di supporto è qui per aiutarvi.' : 
             'Unser Support-Team ist für Sie da.'}
          </p>
          <a 
            href="mailto:ciao@centeo.one" 
            className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            {lang === 'es' ? 'Contactar Soporte' : 
             lang === 'it' ? 'Contatta il Supporto' : 
             'Support kontaktieren'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;